import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components';
import { THEME } from '../../genericComponents/globalStyles';
import HorizontalSelector from '../../genericComponents/HorizontalSelector';
import { RowTypeSpaceBetween } from '../../genericComponents/Layouts';
import ShadowCard from '../../genericComponents/ShadowCard';
import Text from '../../genericComponents/Text';
import { PrymaryButton } from '../../genericComponents/Button';
import { Select, Modal } from 'antd';
import {useTranslation} from 'react-i18next'; 
import { CloseOutlined } from '@ant-design/icons';


export default function AmplifiersModal({
  isModalVisible,
  setIsModalVisible,
  productsJson,
  typePower,
  powerRerquirement,
  setManualSelectedAmplifier,
  showAmplifier
}){
  const { t } = useTranslation();
  const [multiWay, setMultiWay] = useState('all');
  const [control, setControl] = useState('all');
  const [mixer, setMixer] = useState('all');
  const [talkover, setTalkover] = useState('all');
  const [player, setPlayer] = useState('all');
  const [dsp, setDsp] = useState('all');
  const [filteredAmplifiers, setFilteredAmplifiers] = useState([]);
  const [amplifierSelected, setAmplifierSelected] = useState()

  useEffect(() => {
    if(productsJson&&isModalVisible){
      const newAmplifiers = productsJson?.amplifiers?.filter(f=>{
        if(f[typePower]!=="1")return false;
        if(control!=='all'&&control!==f.control)return false;
        if(mixer!=='all'&&mixer!==f.mixer)return false;
        if(talkover!=='all'&&talkover!==f.talkOver)return false;
        if(player!=='all'&&player!==f.player)return false;
        if(dsp!=='all'&&dsp!==f.DSP)return false;
        if(multiWay!=='all'&&f.multiChannel!==multiWay){
          if(multiWay==='+4'){
            if(f.multiChannel<3)return false
          }else return false;
        }
        return true;
      });
      const firstIndex=newAmplifiers?.findIndex(i=>Number(i.power)>=powerRerquirement);
      // console.log(newAmplifiers)
      // console.log(firstIndex)
      const restAmplifiers = newAmplifiers.splice(0,firstIndex);

      newAmplifiers.splice(newAmplifiers.length,0,...(restAmplifiers.reverse()))
      setFilteredAmplifiers(newAmplifiers);
      setAmplifierSelected(null);
    }
  }, [isModalVisible,multiWay,control,mixer,talkover,typePower,player,dsp,productsJson])
  useEffect(() => {
    if(isModalVisible&&showAmplifier){
      setAmplifierSelected({
        idAcAmplifier:showAmplifier.amplifier?.idAcAmplifier,
        quantity:showAmplifier?.quantity
      })
    }
  }, [isModalVisible])

  function applySelected() {
    const finalAmp = productsJson?.amplifiers?.find(r=>r.idAcAmplifier===amplifierSelected.idAcAmplifier)
    setManualSelectedAmplifier({
      amplifier:finalAmp,
      quantity:amplifierSelected.quantity
    })
    setIsModalVisible(false)
  }

  return (
    <ModalContentTotal
      visible={isModalVisible} 
      width={1100}
      footer={null}
      closeIcon={<CloseOutlined style={{color:'#FFF'}}/>}
      onCancel={()=>setIsModalVisible(false)}
    >
      <ModalHeader>{t('select_another_amplifier')}</ModalHeader>
      <FilterContainer>
        <FilteringContent>
          <Text titleSize={2} titleLevel={1}>{t('advance_filters')}</Text>
          <FilteringControlsContainer>
            <ColumnCenter>
              <Text titleSize={2} titleLevel={1}>{t('multi_channel')}</Text>
              <HorizontalSelector
                style={{minWidth:140}}
                options={[{value:'all',text:t('all')},{value:'0',text:'1'},{value:'1',text:'2'},{value:'2',text:'4'},{value:'+4',text:'+4'}]}
                selected={multiWay}
                onChange={(o)=>setMultiWay(o.value)}
              />
            </ColumnCenter>
            
            <ColumnCenter>
              <Text titleSize={2} titleLevel={1}>{t('player')}</Text>
              <HorizontalSelector
                style={{minWidth:140}}
                options={[{value:'all',text:t('all')},{value:'1',text:t('yes')},{value:'0',text:t('no')}]}
                selected={player}
                onChange={(o)=>setPlayer(o.value)}
              />
            </ColumnCenter>
            <ColumnCenter>
              <Text titleSize={2} titleLevel={1}>{t('mixer')}</Text>
              <HorizontalSelector
                style={{minWidth:140}}
                options={[{value:'all',text:t('all')},{value:'1',text:t('yes')},{value:'0',text:t('no')}]}
                selected={mixer}
                onChange={(o)=>setMixer(o.value)}
              />
            </ColumnCenter>
            <ColumnCenter>
              <Text titleSize={2} titleLevel={1}>{t('talover')}</Text>
              <HorizontalSelector
                style={{minWidth:140}}
                options={[{value:'all',text:t('all')},{value:'1',text:t('yes')},{value:'0',text:t('no')}]}
                selected={talkover}
                onChange={(o)=>setTalkover(o.value)}
              />
            </ColumnCenter>
            <ColumnCenter>
              <Text titleSize={2} titleLevel={1}>{t('control')}</Text>
              <HorizontalSelector
                style={{maxWidth:200}}
                childStyle={{padding:'0px 4px'}}
                options={[{value:'all',text:t('all')},{value:'0',text:'Ethernet'},{value:'1',text:'Serial port'}]}
                selected={control}
                onChange={(o)=>setControl(o.value)}
              />
            </ColumnCenter>
            <ColumnCenter>
              <Text titleSize={2} titleLevel={1}>{t('DSP')}</Text>
              <HorizontalSelector
                style={{minWidth:140}}
                options={[{value:'all',text:t('all')},{value:'1',text:t('yes')},{value:'0',text:t('no')}]}
                selected={dsp}
                onChange={(o)=>setDsp(o.value)}
              />
            </ColumnCenter>
          </FilteringControlsContainer>
        </FilteringContent>
      </FilterContainer>
      {filteredAmplifiers?.length>0?
        <Text style={{textAlign:'center',margin:'8px 20px'}} titleSize={2} titleLevel={1}>
          {t('results')}
        </Text>
      :
        <Text style={{textAlign:'center',margin:'32px 0 0 0'}} titleSize={3} titleLevel={1}>
          {t('there_are_no_results_for_your_search')}
        </Text>
      }
      <ScrollContainer>
        {filteredAmplifiers?.map((amp,i)=>(
          <AmplifierCard 
            key={i}
            t={t}
            amp={amp}
            onSelect={(d)=>setAmplifierSelected(old=>old?.idAcAmplifier===d?.idAcAmplifier?null:d)}
            selected={amplifierSelected}
            lowImpedance={typePower==='lowImpedance'}
            powerRerquirement={powerRerquirement}
          />
        ))}
      </ScrollContainer>
      <FooterContainer>
        <div style={{display:'flex'}}>

          <PrymaryButton secondary onClick={()=>setIsModalVisible(false)}>
            {t('cancel')}
          </PrymaryButton>
          <div style={{width:80}}/>
          <PrymaryButton disabled={amplifierSelected?false:true} onClick={applySelected}>
            {t('apply')}
          </PrymaryButton>
        </div>

      </FooterContainer>
    </ModalContentTotal>
  )
}

function AmplifierCard({t,amp,selected,onSelect,lowImpedance,powerRerquirement}){
  const amplifierQuantity = useRef(1);
  const langSelected = localStorage.getItem("i18nextLng") || "en";
  function changeQuantity(n) {
    amplifierQuantity.current = n;
    onSelect({
      idAcAmplifier:amp?.idAcAmplifier,
      quantity:n
    });
  }
  const amplifierSlogan = (langSelected==='es'?amp?.slogan_100:amp?.slogan_101)?.split('. ');

  return(
    <ShadowCard 
      clickable={true} 
      selected={selected?.idAcAmplifier===amp?.idAcAmplifier}
      className={'amplifiercard'}
      onClick={()=>onSelect({
        idAcAmplifier:amp?.idAcAmplifier,
        quantity:lowImpedance?(amplifierQuantity.current):Math.ceil(powerRerquirement/Number(amp.power))
      })} 
    >
      {!lowImpedance&&(powerRerquirement/Number(amp.power)<=1)&&<BlueLabel>{t('unit_meets_power_requirement')}</BlueLabel>}
      <RowTypeSpaceBetween style={{maxHeight:"40px"}}>
        <div style={{display:'flex',alignItems:'center'}}>
          {lowImpedance?
            <>
              <Text titleSize={1} titleLevel={3}>{t('quantity')}</Text>
              <CustomSelect value={amplifierQuantity.current} onChange={changeQuantity} style={{width:60,margin:"0 10px"}}>
                {Array(50).fill({}).map((_,i)=><Select.Option value={i+1}>{i+1}</Select.Option>)}
              </CustomSelect>
            </>
          :
            <QuantityCircle>
              <Text titleSize={2} titleLevel={3} strong>{Math.ceil(powerRerquirement/Number(amp.power))}x</Text>
            </QuantityCircle>
          }
          <Text  titleSize={2} titleLevel={4}>{t('model')}: <strong>{amp?.name}</strong></Text>
        </div>
        <img 
          alt=""
          height={35}
          style={{maxHeight:40}}
          src={amp?.brandlogo}
        />
      </RowTypeSpaceBetween>
      <RowTypeSpaceBetween>
        <div>
          <Text titleSize={1} titleLevel={3}>{amplifierSlogan&&amplifierSlogan[0]}</Text>
          <Text titleLevel={4}>{t('characteristics')}</Text>
          {amplifierSlogan.slice(1).map((f,i)=>
            <Text key={i} titleLevel={4}>• {f}</Text>
          )}
        </div>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
          <img 
            alt=""
            width={160}
            src={`https://media.equipson.es/img/WEB/${amp?.media?.find(m=>m.mediaOrder==="0").path}`} 
          />
        </div>
      </RowTypeSpaceBetween>
   </ShadowCard>
  )
}

const ModalContentTotal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
    overflow:hidden;
  }
  .ant-modal-content {
    border-radius: 12px;
  }
`;
const ModalHeader = styled.div`
  width: 100%;
  padding: 12px;
  text-align: center;
  font-size: 1.2em;;
  background-color: ${THEME.colors.blue};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  color: #FFF;
`;
const FilterContainer = styled(RowTypeSpaceBetween)`
  border-bottom: solid 1px #EEE;
`;
const CustomSelect = styled(Select)`
  width: 100%;
  color:${THEME.colors.darkBlue};
  span{
    color:${THEME.colors.darkBlue};
  }
`;
const FilteringContent = styled.div`
  display:flex;
  flex:1;
  flex-direction: column;
  background-color:#EEE;
  padding:16px 16px 6px 16px;
`;
const FilteringControlsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 940px) {
    justify-content: flex-start;
  }
`;
const ColumnCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 8px;
`;
const ScrollContainer = styled.div`
  max-height: 450px;
  min-height: 200px;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 6px;
  ::-webkit-scrollbar{
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background-color: #EEE;
    border-radius: 12px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${THEME.colors.blue}bb; 
    border-radius: 12px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${THEME.colors.blue}aa;
  }
  .amplifiercard{
    width:48%;
    padding-bottom :0;
    position:relative;
    @media (max-width: 800px) {
      width: 90%;
    }
  }
`;
const FooterContainer = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: solid 1px ${THEME.colors.ligthBlue};
`;
const QuantityCircle = styled.div`
  min-width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 4px 0 4px;
  border: 1px solid ${THEME.colors.blue};
  border-radius: 50px;
  margin-right: 6px;
`;
const BlueLabel = styled.div`
  position: absolute;
  background: ${THEME.colors.blue}77;
  padding: 0 8px;
  top:-2px;
  right: 8px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  color: #FFF;
  font-size: 0.7em;
`;